import { useEffect } from "react";
import { array, object, node, string } from "prop-types";
import Container100 from "../Container/Container100.jsx";
import * as R from "ramda";
import "./department-listing.scss";
import ContentfulLink from "../ContentfulLink/ContentfulLink.jsx";
import "aos/dist/aos.css";
import AOS from "aos";

const propTypes = {
  deptList: array,
  deptListText: node,
};

const DepartmentListing = (props) => {
  const { deptList, deptListText } = props;
  const deptArray = R.compose(
    R.map((i) => R.merge({ state: i[0] }, { depts: i[1] })),
    R.toPairs,
    R.groupBy(R.path(["department", "state"])),
    R.filter(R.hasPath(["department", "state"])),
  )(deptList);

  const sortedDeptArray = R.sortBy(R.prop("state"), deptArray);

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Container100>
      <div className="department-list">
        <div className="department-list__text">{deptListText}</div>
        {deptList.length > 0 && (
          <ul className="department-list__wrapper">
            {sortedDeptArray.map((item, k) => (
              <li key={k}>
                <h3 className="department-list__state-title">{item.state}</h3>
                <ul>
                  {/* want individual departments in alphabetical order */}
                  {R.sortBy(R.prop("url"), item.depts).map((d, k) => {
                    return d?.department?.name ? (
                      <li key={d?.id}>
                        <ContentfulLink
                          className="department-list__dept-link btn btn--text"
                          to={`/department/${d?.url}`}
                          type="internal"
                        >
                          {d?.department?.name}
                        </ContentfulLink>
                      </li>
                    ) : (
                      false
                    );
                  })}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Container100>
  );
};

DepartmentListing.propTypes = propTypes;
export default DepartmentListing;
